var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { currentAccountState, currentUserState } from '../components';
import { useRecoilValue } from 'recoil';
import { makeRemoteLogin } from '@/main/factories/usecases';
const login = makeRemoteLogin();
function useUserSesssion() {
    const { getCurrentUser, setCurrentUser } = useRecoilValue(currentUserState);
    const { getCurrentAccount } = useRecoilValue(currentAccountState);
    const currentUserSession = getCurrentUser();
    const currentCognitoAccount = getCurrentAccount();
    const getIdClient = () => {
        var _a, _b, _c, _d, _e;
        if ((_b = (_a = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.user) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.id)
            return (_d = (_c = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.user) === null || _c === void 0 ? void 0 : _c.client) === null || _d === void 0 ? void 0 : _d.id;
        else {
            console.error(`No client in user session, userRole[${(_e = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.user.role) === null || _e === void 0 ? void 0 : _e.description}]`);
            return null;
        }
    };
    const getClient = () => {
        var _a, _b, _c, _d;
        if ((_b = (_a = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.user) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.id)
            return (_c = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.user) === null || _c === void 0 ? void 0 : _c.client;
        else {
            console.error(`No client in user session, userRole[${(_d = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.user.role) === null || _d === void 0 ? void 0 : _d.description}]`);
            return null;
        }
    };
    const isCognitoWatcherCheck = () => {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = currentCognitoAccount === null || currentCognitoAccount === void 0 ? void 0 : currentCognitoAccount.attributes) === null || _a === void 0 ? void 0 : _a.email) &&
            ((_b = currentCognitoAccount === null || currentCognitoAccount === void 0 ? void 0 : currentCognitoAccount.attributes) === null || _b === void 0 ? void 0 : _b.profile) &&
            ((_c = currentCognitoAccount === null || currentCognitoAccount === void 0 ? void 0 : currentCognitoAccount.attributes) === null || _c === void 0 ? void 0 : _c.email.length) > 5 &&
            ((_d = currentCognitoAccount === null || currentCognitoAccount === void 0 ? void 0 : currentCognitoAccount.attributes) === null || _d === void 0 ? void 0 : _d.profile.length) > 5 &&
            ((_f = (_e = currentCognitoAccount === null || currentCognitoAccount === void 0 ? void 0 : currentCognitoAccount.attributes) === null || _e === void 0 ? void 0 : _e.email) === null || _f === void 0 ? void 0 : _f.includes('watcher'))) {
            console.warn('Cognito watcher detected');
            return true;
        }
        return false;
    };
    const updateUserSession = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            const loginStatus = yield login.loginStatus();
            if ((_a = loginStatus.user) === null || _a === void 0 ? void 0 : _a.id) {
                setCurrentUser(loginStatus);
                return true;
            }
        }
        catch (error) {
            console.error(error);
        }
        return false;
    });
    const isCognitoWatcher = isCognitoWatcherCheck();
    return { user: currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.user, getIdClient, currentUserSession, getClient, updateUserSession, isCognitoWatcher };
}
export default useUserSesssion;
